<template>
    <b-collapse id="content" visible>
        <card>
            <b-row>
                <b-col cols="12">
                    <card type="default" header-classes="bg-transparent">
                        <b-row slot="header">
                            <b-col>
                                <h5 class="h3 text-white mb-0">Volume By Day By Drug</h5>
                            </b-col>
                        </b-row>
                        <line-chart :height="350"
                                    ref="bigChart"
                                    :chart-data="myChartData">
                        </line-chart>
                    </card>
                </b-col>
            </b-row>
        </card>
    </b-collapse>
</template>

<script>
    import * as chartConfigs from '@/components/Charts/config';
    import LineChart from '@/components/Charts/LineChart';
    import BarChart from '@/components/Charts/BarChart';
    import { match } from 'core-js/fn/symbol';


    function generateColorPalette(startColor, endColor, steps) {
        var start = {
            'Hex': startColor,
            'R': parseInt(startColor.slice(1, 3), 16),
            'G': parseInt(startColor.slice(3, 5), 16),
            'B': parseInt(startColor.slice(5, 7), 16)
        }
        var end = {
            'Hex': endColor,
            'R': parseInt(endColor.slice(1, 3), 16),
            'G': parseInt(endColor.slice(3, 5), 16),
            'B': parseInt(endColor.slice(5, 7), 16)
        }
        let diffR = end['R'] - start['R'];
        let diffG = end['G'] - start['G'];
        let diffB = end['B'] - start['B'];

        let stepsHex = new Array();6
        let stepsR = new Array();
        let stepsG = new Array();
        let stepsB = new Array();

        for (var i = 0; i <= steps; i++) {
            stepsR[i] = start['R'] + ((diffR / steps) * i);
            stepsG[i] = start['G'] + ((diffG / steps) * i);
            stepsB[i] = start['B'] + ((diffB / steps) * i);
            stepsHex[i] = '#' + Math.round(stepsR[i]).toString(16) + '' + Math.round(stepsG[i]).toString(16) + '' + Math.round(stepsB[i]).toString(16);
        }
        return stepsHex;
    }
    export default {
        name: 'DrugVolumeCharts',
        components: {
            LineChart
        },
        props: {
            apiEndpoint: String,
        },
        data() {
            return {
                myChartData: {
                    datasets: [
                        {
                            label: '',
                            data: [],
                        }
                    ],
                    labels: [],
                }
            }
        },
        methods: {
            fetchData() {
                this.axios.get(this.apiEndpoint)
                    .then(response => {
                        let chartData = {
                            datasets: [],
                            labels: [],
                        };
                        chartData.labels = [...new Set(response.data.map(x => x.filledDate.replace('T00:00:00', '')))];

                        function groupBy(list, keyGetter) {
                            const map = new Map();
                            list.forEach(item => {
                                const key = keyGetter(item);
                                const collection = map.get(key);
                                if (!collection) {
                                    map.set(key, [item]);
                                } else {
                                    collection.push(item);
                                }
                            });

                            return map;
                        }

                        let drugsData = groupBy(response.data, d => d.drugName);
                        let allDatasets = []
                        let startingColor = '#04a7ff'
                        let endingColor = '#fff200'
                        let steps = drugsData.size + 1
                        let colorPalette = generateColorPalette(startingColor, endingColor, steps)
                        let index = 1

                        drugsData.forEach(drug => {
                            //each kind of drug

                            var dataset = {
                                label: drug[0].drugName,
                                data: [],
                                backgroundColor: colorPalette[index] + "3B",
                                borderColor: colorPalette[index],
                            }
                            //for each label date, if drug has a matching date, push that drug's amount, otherwise push 0
                            chartData.labels.forEach(currentDate => {
                                var dateIndex = drug.map(e => e.filledDate.replace('T00:00:00', '')).indexOf(currentDate);
                                if (dateIndex != -1) {
                                    dataset.data.push(drug[dateIndex].amount)
                                }
                                else {
                                    dataset.data.push(0);
                                }
                            })
                            allDatasets.push(dataset);
                            index++;

                        });
                        chartData.datasets = allDatasets;
                        this.myChartData = chartData;
                        
                    })
                    .catch(error => {
                        
                    });

            },

        },
        watch: {
            apiEndpoint(newEndpoint, oldEndpoint) {
                this.fetchData();
            },
        },
    }
</script>

<style scoped>
</style>